import React from 'react';
import { string, number } from 'prop-types';
import { connect } from 'react-redux';

import { TagSolidIcon } from '@snapask/common-components';

import {
  getCurriculumName,
  getSubjectName,
  getTopicName,
  getSubtopicName,
  getSubjectId,
  getSubtopicId,
} from '@blueberry/redux/post';

import styles from './TagBlock.scss';
import { Link } from 'react-router-dom';

const mapStateToProps = state => ({
  curriculumName: getCurriculumName(state),
  subjectName: getSubjectName(state),
  subjectId: getSubjectId(state),
  topicName: getTopicName(state),
  subtopicName: getSubtopicName(state),
  subtopicId: getSubtopicId(state),
});

function TagBlock({
  curriculumName,
  subjectName,
  topicName,
  subtopicName,
  subtopicId,
  subjectId,
}) {
  if (!subjectName) {
    return <div />;
  }

  return (
    <div className={styles.root}>
      <TagSolidIcon height={25.6} width={16} className={styles.icon} />
      <div className={styles.tagBlock}>
        <span className={styles.tag}>{curriculumName}</span>
        <Link
          to={`/subject/${subjectName}-${subjectId}`}
          className={styles.tag}
        >
          {subjectName}
        </Link>
        {!!topicName && <span className={styles.tag}>{topicName}</span>}
        {!!subtopicName && (
          <Link
            to={`/subject/${subjectName}-${subjectId}/${subtopicName}-${subtopicId}`}
            className={styles.tag}
          >
            {subtopicName}
          </Link>
        )}
      </div>
    </div>
  );
}

TagBlock.propTypes = {
  curriculumName: string,
  subjectId: number,
  subjectName: string,
  subtopicId: number,
  subtopicName: string,
  topicName: string,
};

TagBlock.defaultProps = {
  curriculumName: '',
  subjectId: 0,
  subjectName: '',
  subtopicId: 0,
  subtopicName: '',
  topicName: '',
};

export default connect(mapStateToProps)(TagBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/TagBlock/TagBlock.jsx